export default [
  {
    name: 'ineps',
    path: '/ineps',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Escolas',
      icon: 'dvr',
      label: 'Escolas',
      roles: ['Admin']
    }
  }
]
